@let gridData = $gridData();
@let T = gridData.data;
<unity-grid-shared
  gridTitle=""
  [gridError]="$gridError()"
  [gridData]="gridData"
  [gridLoading]="$gridLoading()"
  [defaultSort]="defaultSort"
  [defaultFilter]="defaultFilter"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="name" title="Name">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="item.name" [link]="['/form-template', item.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="description" title="Description" />
  <kendo-grid-column field="type.name" title="Type" />
  <kendo-grid-column field="default_workflow.name" title="Workflow" />
  <kendo-grid-column field="current_state.name" title="Status">
    <ng-template let-item kendoGridCellTemplate [unityTyped]="T">
      <unity-chip-workflow-state-shared [name]="item.current_state.name" [value]="item.current_state.enum_value" />
    </ng-template>
  </kendo-grid-column>
</unity-grid-shared>
